// Client copy of normalizeInstagram in api/_lib/innerCircle.mjs; keep the two
// in sync. Accepts "handle", "@handle" or an instagram.com profile URL and
// returns the lowercased handle, or null if it can't be an Instagram username.
const NON_HANDLE_SEGMENTS = new Set(["p", "reel", "reels", "stories", "explore", "tv", "accounts", "direct"]);

export function normalizeInstagram(raw) {
  let value = String(raw ?? "").trim();
  if (!value) return null;

  const urlMatch = value.match(/^(?:https?:\/\/)?(?:www\.|m\.)?instagram\.com\/@?([^/?#\s]+)/i);
  if (urlMatch) {
    value = urlMatch[1];
    if (NON_HANDLE_SEGMENTS.has(value.toLowerCase())) return null;
  }

  value = value.replace(/^@+/, "").toLowerCase();
  if (!/^[a-z0-9._]{1,30}$/.test(value)) return null;
  if (value.startsWith(".") || value.endsWith(".") || value.includes("..")) return null;
  return value;
}
